import React from "react"

function Heart({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.9006 11.268C23.7747 10.9328 25.3818 12.0777 25.8859 14.0506"
        stroke="#003E4C"
        strokeWidth="1.00138"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7021 11.4506C19.9556 7.32131 24.4613 7.32131 26.7148 9.38596C28.9677 11.4506 28.9677 15.5806 26.7148 19.7106C25.1373 22.8076 21.0817 25.9053 17.7021 27.97C14.3225 25.9053 10.2669 22.8076 8.69013 19.7106C6.43662 15.5806 6.43662 11.4506 8.69013 9.38596C10.9429 7.32131 15.4493 7.32131 17.7021 11.4506Z"
        stroke="#003E4C"
        strokeWidth="1.00263"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Heart
